import { render, staticRenderFns } from "./result_demo.vue?vue&type=template&id=6a5edbf6"
import script from "./result_demo.vue?vue&type=script&lang=js"
export * from "./result_demo.vue?vue&type=script&lang=js"
import style0 from "./result_demo.vue?vue&type=style&index=0&id=6a5edbf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports